import React from "react";
import Dropzone from "react-dropzone";

// for pdf files
class FileUpload extends React.Component {
  state = { warningMsg: "" };

  onDrop = (accepted, rejected) => {
    if (Object.keys(rejected).length !== 0) {
      const message = "Please submit a valid .pdf file(max size: 5MB)";  
      this.props.hasFileError(true); 
      this.setState({ warningMsg: message });
    } else {
      this.props.addFile(accepted);
      console.log(accepted)
      this.setState({ warningMsg: "" });
      console.log(accepted[0].preview);

      var blobPromise = new Promise((resolve, reject) => {
        const reader = new window.FileReader();
        reader.readAsDataURL(accepted[0]);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data);
        };
      });
      blobPromise.then(value => {
        this.props.fileBaseValue(value,accepted[0]);
      });
    }
  };

  render() {
    const { files } = this.props;
    const render =
      Object.keys(files).length !== 0 ? (
        // files.map(file => <p  className="hello" key={file.name} style={{width: '100%',marginTop: '1%'}}>Uploaded File: { file.name.length<=50 ? file.name : `...${file.name.slice(-30)}` }        
        files.map(file => <p  className="hello" key={file.name} style={{textAlign: 'left', height: '20px', marginTop: '1%'}}>
        {/* Uploaded File: {this.props.fileName} */}
        </p>)        
      ) : (
        <p className="hello" style={{ textAlign: 'left',height: '20px', marginTop: '1%'}}>
        {/* Drag and Drop or Attach files */}
        </p>
      );
    return (
      <div style={{width: '100%'}}>
       {/* {this.state.warningMsg==='' ?  <p>{this.state.warningMsg}</p> : null } */}
        <Dropzone
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // height: "50vh",
            // border: " 2px dashed"
          }}
          multiple={false}
          maxSize={5242880}
        //   accept="application/msword, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          accept="application/pdf,"
          onDrop={(accepted, rejected) => this.onDrop(accepted, rejected)}
          onClick={false}
          
        >
          {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }) => {
            if (isDragReject) return " ";
            return render;
          }}
        </Dropzone>
      </div>
    );
  }
}

export default FileUpload;
